export const routes = {
  home: "/",
  solutions: "/solutions",
  project: "/project",
  references: "/references",
  aboutUs: "/about-us",
  contact: "/contact",
  legal: "/legal",
  termsOfUse: "/terms-of-use"
};

export const routeId = "/:id";

export const Anchors = {};
